<style lang="scss">
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/colors";
  .container {
    display: flex;
    flex-direction: column;

    $pad-dist: utils.in_rem(22px);

    padding: $pad-dist 0 $pad-dist $pad-dist;
    > * {
      padding-right: $pad-dist;
    }

    border-radius: utils.in_rem(12px);
    background-color: #f7f7f7;
    gap: utils.in_rem(12px);
    overflow: hidden;
    > h3 {
      flex: 0;
    }

    > image {
      flex: 0;
      align-self: center;
      width: 100%;
      margin-bottom: utils.in_rem(22px);
    }
    > .contents {
      flex: 1;
      overflow: auto;
      .contents-inner {
        @include mixins.body2();
        @include colors.color(textGrey);
      }
    }
  }
</style>

<script>
  let cls = "";
  export { cls as class };
  export let style = "";
  export let image = "";
  export let heading = "";
</script>

<div class="container {cls}" class:image class:heading {style}>
  {#if image}
    <img src={image} alt={heading} />
  {/if}
  {#if heading}
    <h3>{heading}</h3>
  {/if}
  <div class="contents">
    <div class="contents-inner">
      <slot />
    </div>
  </div>
</div>
